import React, { createContext, useContext } from 'react';

const PartnerContext = createContext();

/**
 * PartnerProvider is now a no-op shell.
 * All co-branding detection, UTM sniffing, and dynamic partner content has been removed
 * to prevent Google Ads policy violations from dynamic content injection.
 * 
 * A generic coupon code field remains on the Loesning page for NexBlue Edge 2 only.
 */
export function PartnerProvider({ children }) {
  return (
    <PartnerContext.Provider value={{
      activePartner: null,
      couponApplied: false,
      partnersLoaded: true,
      validateCoupon: () => false,
      getDiscountedPrice: (p) => p,
      getPreviewDiscount: (p) => p,
      getVismaPrice: (p) => p,
      hasPartnerDiscount: () => false,
      getDiscountAmount: () => 0,
      isDiscountedCharger: () => false,
      isActiveOnPage: () => false,
      clearPartner: () => {},
      setCouponApplied: () => {},
      getProductOverride: () => null,
      getPartnerMessaging: () => ({}),
      getPartnerType: () => 'discount',
      getValueLabel: () => 'Rabat',
      getCashbackTotal: () => ({ total: 0, items: [] }),
      isCashbackUIHidden: () => false
    }}>
      {children}
    </PartnerContext.Provider>
  );
}

export function usePartner() {
  const context = useContext(PartnerContext);
  if (!context) {
    throw new Error('usePartner must be used within a PartnerProvider');
  }
  return context;
}

export default PartnerContext;